module.exports = __webpack_public_path__ + "assets/images/0d67bc5afe73c2438d40bcfc206d3121.png";